import { useCallback } from 'react';

import { useSaveTreatmentPlanV3PageField } from '../../../../hooks';
import { toTreatmentFieldPayload } from '../utils';
import { TREATMENT_FORM_SCHEMA } from '../validationSchema';
import {
  getAssessmentHoursSiblingName,
  getTreatmentFieldCompareValue,
  getTreatmentServicePairedFieldNames,
} from './utils';

import type { SaveField } from '../../../../../common';
import type { TreatmentFormValues } from '../types';
import type { SaveTreatmentFieldParams } from './types';

export default function useSaveTreatmentField({
  formik,
  savedValues,
  onUpdate,
}: SaveTreatmentFieldParams) {
  const { saveField: savePageField } = useSaveTreatmentPlanV3PageField({
    formik,
    getCompareValue: getTreatmentFieldCompareValue,
    getLinkedFieldNames: getTreatmentServicePairedFieldNames,
    initialValues: savedValues,
    onUpdate,
    toPayload: toTreatmentFieldPayload,
    validationSchema: TREATMENT_FORM_SCHEMA,
  });

  const saveField: SaveField<TreatmentFormValues> = useCallback(
    async (name, value) => {
      await savePageField(name, value);
      const siblingName = getAssessmentHoursSiblingName(name);
      if (siblingName) await savePageField(siblingName);
    },
    [savePageField],
  );

  return { saveField };
}
